import React from "react"
import Container from "../../Container"
import ImageWrapper from "../../ImageWrapper"
import Section from "../../Section"
import TextWrapper from "../../TextWrapper"
import { ListItem, UnorderedList } from "../../UnorderedLists"
import CheckMark from "../../../../images/home/check.svg"
import IconHeadingTitle from "../../IconHeadingTitle"
import activityTimelineData from "../../../../data/pageSections/platform/offers/activityTimeline"

const ActivityTimelineDates = () => {
  const {
    titleIcon,
    title,
    description,
    graphic,
    imageLeft,
    benefits,
    tint,
    textLong,
  } = activityTimelineData

  return (
    <Section tint={tint} className="padding-tb-0">
      <Container>
        <TextWrapper imageLeft={imageLeft} long={textLong}>
          <IconHeadingTitle icon={titleIcon} title={title} />
          {description}
          <UnorderedList>
            {benefits &&
              benefits.map(({ benefitName }) => (
                <ListItem>
                  <img
                    className="margin-right-10"
                    src={CheckMark}
                    alt="check"
                    title="check"
                  />
                  {benefitName}
                </ListItem>
              ))}
          </UnorderedList>
        </TextWrapper>
        <ImageWrapper imageLeft={imageLeft} half={!textLong}>
          {graphic}
        </ImageWrapper>
      </Container>
    </Section>
  )
}

export default ActivityTimelineDates
